import React, {Component} from 'react';
import {browserHistory} from 'react-router'

export default class PopupCancel extends Component {


    handlePopupCancel(e) {
        browserHistory.push(`/ChooseServices/`)
    }

    render() {
        return (
            <div id="popup-hair" className="slickModal isActive"
                 style={{"transition-duration": "0.4s"}}>
                <div className="slickOverlay closeModal setSlickCookie"
                     style={{'background': 'rgba(0, 0, 0, 0.85098)', 'transition-duration': '0.4s'}}></div>
                <div className="slickWindow center animated  messageEdit">
                    <div className="wrap">
                        <div className="popup-icon"></div>
                        <h3 class="subtitle">Thank you. Your appointment has been cancelled.</h3>
                    </div>
                    <button
                        type="submit"
                        className="button btn-primary buttonEdit"
                        onClick={this.handlePopupCancel}
                    >
                        Book another appointment
                    </button>
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/PopupCancel.js
 **/